import { useRef, useState } from 'react'
import Button from 'antd/es/button'
import Card from 'antd/es/card'
import Row from 'antd/es/row'
import IdeyaTypography from '../../common/antd/ideya-typography'
import { useAppSelector } from '../../redux/hooks.ts'
import { selectThemeStyle } from '../../features/setting/setting.slice.ts'
import { useNavigate } from 'react-router-dom'
import { useIsMobile } from '../../common/hooks/use-is-mobile.ts'
import { VerticalAlignBottomOutlined } from '@ant-design/icons'
import backgroundDisclaimer from '../../assets/background-disclaimer.png'
import Paragraph from 'antd/es/typography/Paragraph'

export const Disclaimer = () => {
  const scrollRef = useRef<HTMLDivElement>(null)
  const [scrolledToBottom, setScrolledToBottom] = useState(false)
  const themeStyle = useAppSelector(selectThemeStyle)
  const navigate = useNavigate()

  const isMobile = useIsMobile(768)

  const handleScroll = () => {
    const el = scrollRef.current
    if (el) {
      const atBottom = el.scrollTop + el.clientHeight >= el.scrollHeight - 2
      setScrolledToBottom(atBottom)
    }
  }

  const handleAccept = () => {
    if (scrolledToBottom) {
      localStorage.setItem('disclaimerAccepted', 'true')
      navigate('/idea')
    } else {
      alert('Please scroll to the bottom to accept the terms.')
    }
  }

  const handleScrollClick = () => {
    // Instead of downloading, scroll to the bottom of the disclaimer
    const el = scrollRef.current
    if (el) {
      el.scrollTo({ top: el.scrollHeight, behavior: 'smooth' })
    }
  }

  return (
    <div
      style={{
        minHeight: '100vh',
        width: '100vw',
        background: `#f5f5f5 url(${backgroundDisclaimer}) no-repeat center center`,
        backgroundSize: 'cover',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        position: 'relative',
        padding: isMobile ? '8px 0' : undefined,
      }}
    >
      <div
        style={{
          justifyContent: 'center',
          marginBottom: themeStyle.marginBase,
        }}
      >
        <IdeyaTypography.Title
          level={2}
          style={{
            marginBottom: 16,
            fontSize: isMobile ? 20 : undefined,
            textAlign: isMobile ? 'center' : undefined,
            padding: isMobile ? '0 8px' : undefined,
          }}
        >
          IDEYA Terms For Authorized Users
        </IdeyaTypography.Title>
      </div>
      <Card
        style={{
          width: isMobile ? '98vw' : 1320,
          maxWidth: '98vw',
          //minHeight: isMobile ? 'unset' : 630,
          //maxHeight: isMobile ? 'unset' : 900,
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'space-between',
          //boxShadow: '0 4px 24px rgba(0,0,0,0.12)',
          border: `1px solid #d9d9d9`,
          borderRadius: '8px',
          position: 'relative',
          margin: '0 auto',
          padding: '0px 12px',
        }}
        styles={{
          body: {
            padding: 0,
          },
        }}
      >
        <div
          style={{
            overflowY: 'auto',
            maxHeight: isMobile ? '60vh' : 520,
            minHeight: isMobile ? 200 : 300,
            marginBottom: 24,
            paddingRight: 8,
            background: '#fff',
            position: 'relative',
          }}
          ref={scrollRef}
          onScroll={handleScroll}
        >
          <Row
            style={{
              padding: isMobile
                ? `${themeStyle.paddingSM} ${themeStyle.paddingXS}`
                : `${themeStyle.paddingLG} ${themeStyle.paddingXL} 0px ${themeStyle.paddingXL}`,
              textAlign: 'justify',
            }}
            gutter={[16, 16]}
          >
            <IdeyaTypography.Text>
              Please carefully read this important information before entering
              this website as an authorized user. It contains legal and
              regulatory notices relevant to the information that you will be
              able to access on and through this website. By entering, accessing
              and/or using this website, you agree to be bound by these terms
              and conditions.
            </IdeyaTypography.Text>
            <b>
              If you do not accept these terms and conditions, please do not
              continue to use or access any pages of this website.
            </b>
            <IdeyaTypography.Text>
              By clicking “Accept” below, you confirm that you have the
              necessary authority to form an agreement on behalf of your firm,
              and agree to form an agreement between you, acting on your own
              behalf and on behalf of the company that you are employed by or
              engaged as a consultant or representative for (“your firm”, and
              collectively “you”) and Polymer Capital Management (HK) Ltd
              (“PCMHK”) which provides access to the Polymer Alpha Capture
              System website (“IDEYA”). This agreement governs your access and
              use of IDEYA. In case of any inconsistency between these terms and
              conditions and the terms and conditions as otherwise agreed in
              writing between you and PCMHK (if any), the latter shall prevail
              and govern, to the extent of such inconsistency.
            </IdeyaTypography.Text>
            <IdeyaTypography.Text>
              These terms may be changed at any time, and each time you click
              “Accept” you are agreeing to the terms in place at the time you
              click. You are expected to check this page from time to time to
              take notice of any changes, as they are binding on you. If you do
              not agree to any such changes, your only recourse will be to
              choose not to access to IDEYA or forfeit your access to IDEYA
              (including all rights granted to you herein). If you continue to
              access IDEYA after any such changes are posted, then your access
              will constitute acceptance of such changes.
            </IdeyaTypography.Text>
            <IdeyaTypography.Title level={4}>
              Important Regulatory Information
            </IdeyaTypography.Title>
            <IdeyaTypography.Text>
              The material contained in IDEYA and the use of it is directed only
              at persons or entities in any jurisdiction or country where such
              access to information contained herein and use thereof is not
              contrary to local law or regulation. Accordingly, all persons who
              access IDEYA are required to inform themselves of and to comply
              with any such laws and regulations.
            </IdeyaTypography.Text>
            <IdeyaTypography.Title level={4}>Compliance</IdeyaTypography.Title>
            <IdeyaTypography.Text>
              All use of IDEYA and submission of trade ideas must be in
              compliance with (a) your firm’s policies and procedures, (b) any
              policies and procedures of any approved alpha capture system that
              you use to capture and/or submit trade ideas, (c) any
              confidentiality or non-disclosure obligations to which you may be
              subject, and (d) all applicable laws, rules and regulations of any
              governmental, regulatory or self-regulatory body or agency,
              including but not limited to any applicable data privacy and state
              secrecy laws, rules and regulations. You represent and warrant
              that your use of IDEYA and submission of trade ideas complies with
              all of the above.
            </IdeyaTypography.Text>
            <IdeyaTypography.Title level={4}>
              Conflict of Interest
            </IdeyaTypography.Title>
            <IdeyaTypography.Text style={{ width: '100%' }}>
              You represent and warrant that your use of IDEYA and submission of
              trade ideas will not present any conflict of interest.
            </IdeyaTypography.Text>
            {isMobile ? (
              <>
                <IdeyaTypography.Title level={4}>
                  Licenses; Submissions;
                </IdeyaTypography.Title>
                <IdeyaTypography.Title level={4}>
                  Risks of Participating in IDEYA
                </IdeyaTypography.Title>
              </>
            ) : (
              <IdeyaTypography.Title level={4}>
                Licenses; Submissions; Risks of Participating in IDEYA
              </IdeyaTypography.Title>
            )}
            <IdeyaTypography.Text>
              You acknowledge that you have a non-exclusive and non-transferable
              right to use IDEYA. You will not permit any other person to use
              IDEYA, whether on a time-sharing, remote job entry or other
              multiple user arrangement. You will not otherwise copy or
              translate, modify, adapt, decompile, disassemble or reverse
              engineer the IDEYA, except as and to the extent expressly
              authorized by applicable law despite this restriction.
            </IdeyaTypography.Text>
            <IdeyaTypography.Text>
              You understand that there is no obligation that any party obtain
              any additional licenses from you, pay you any amounts or share in
              any profits they may make from trading or using on your
              submissions; provided, that, PCMHK may, in its sole discretion,
              compensate you as described below, either directly or indirectly
              through a third party as designated by PCMHK. Unless otherwise
              mutually agreed between the parties, you shall not be entitled to
              any compensation or payment for any submissions you make, any
              trades made by anyone resulting from your submissions, or any
              exercise by any entity of their rights hereunder.
            </IdeyaTypography.Text>
            <IdeyaTypography.Title level={4}>
              Intellectual Property
            </IdeyaTypography.Title>
            <IdeyaTypography.Text>
              Upon submission of any trade ideas, you agree to transfer all
              intellectual property rights of associated with the trade ideas
              and any output generated from your participation in IDEYA
              (collectively “Output”). You understand that PCMHK shall own all
              intellectual property rights in or related to these Outputs. To
              the extent any intellectual property right in such Output remains
              vested in you in accordance with applicable law or regulation, you
              hereby grant PCMHK a royalty-free, perpetual, irrevocable,
              worldwide and non-exclusive licence to use, reproduce, modify,
              display, distribute, and create derivatives works from these
              Outputs in any form and for any purpose, including without
              limitation, making investment decisions that may result in the
              trading of listed or unlisted securities.
            </IdeyaTypography.Text>
            <IdeyaTypography.Title level={4}>Results</IdeyaTypography.Title>
            <IdeyaTypography.Text>
              You understand that if you are provided with the results of actual
              or hypothetical trading on your submissions, those results are
              purely speculative and are based on certain assumptions which may
              or may not be accurate. You should not rely on those results for
              investment purposes, and these results are not necessarily
              indicative of future performance.
            </IdeyaTypography.Text>
            <IdeyaTypography.Title level={4}>
              Confidentiality
            </IdeyaTypography.Title>
            <IdeyaTypography.Text>
              You acknowledge that IDEYA incorporates confidential and
              proprietary information developed or acquired by, or licensed to,
              PCMHK. You agree to take all reasonable precautions necessary to
              safeguard the confidentiality of IDEYA and related information,
              including those that PCMHK or its designee may prescribe from time
              to time. You will not remove or deface of any confidentiality or
              proprietary notice placed on IDEYA. You acknowledge that the
              unauthorized use or dissemination of such confidential and
              proprietary information will cause irreparable harm to PCMHK for
              which there is no adequate remedy at law, and that PCMHK will be
              entitled to injunctive relief in such event.
            </IdeyaTypography.Text>
            <IdeyaTypography.Text>
              You agree to (a) keep all confidential information strictly
              confidential and not to disclose the confidential information to
              any third party without prior written consent as to each
              disclosure, (b) restrict access of confidential information to
              those persons who must receive the submissions to perform under
              this agreement,(c) not to use the confidential information for any
              purpose other than in compliance with these terms; and (d) not to
              disclose to any third party (other than your firm) your
              participation in IDEYA without prior consent of PCMHK. In
              addition, you agree not to publicize your results without prior
              written consent from the entity which generates your results for
              you.
            </IdeyaTypography.Text>
            <IdeyaTypography.Title level={4}>
              Material Non-Public Information
            </IdeyaTypography.Title>
            <IdeyaTypography.Text style={{ width: '100%' }}>
              In connection with each trade idea which you submit to PCMHK or
              its affiliates via IDEYA, you hereby acknowledge and agree to the
              following:
            </IdeyaTypography.Text>
            <Paragraph>
              <ul>
                <li>
                  Your firm has compliance policies and procedures reasonably
                  designed to prohibit the use and transmittal of (i) inside
                  information or confidential, material non-public information
                  and (ii) soon-to-be published research recommendations to
                  which you have been granted early access in compliance with
                  all applicable insider trading laws and regulations, and you
                  agree not to submit any trade ideas based on any inside
                  information or confidential, non-public information or any
                  other information in contravention of your legal, regulatory,
                  or contractual obligations and/or internal policies and
                  procedures.
                </li>
                <li>
                  You understand that:
                  <ul>
                    <li>
                      The information and recommendations that you provide
                      through IDEYA may form part of an investment decision that
                      may result in the trading of listed or unlisted
                      securities; and
                    </li>
                    <li>
                      Neither PCMHK nor any of its affiliates, is seeking and
                      you will not, to the best of your knowledge, provide any
                      material non-public information or any recommendations
                      based on material non-public information; and
                    </li>
                    <li>
                      Neither PCMHK nor any of its affiliates, is seeking and
                      you will not, to the best of your knowledge, provide any
                      information or any recommendations based on information
                      that will breach any contractual, fiduciary or regulatory
                      obligations that you or your firm may have; and
                    </li>
                    <li>
                      The information and recommendations that you provide may
                      be disseminated both within PCMHK, to any of its
                      affiliates, and to third parties, including to regulators
                      and other authorities, without any notice to you.
                    </li>
                  </ul>
                </li>
                <li>
                  You have: (a) all rights required to provide the information
                  and/or recommendations that you are providing hereunder
                  without infringing the rights of any third party; and (b) all
                  licenses and/or approvals from any governmental agency or
                  authority which are required to provide the information and/or
                  recommendations that you are providing via IDEYA. Furthermore,
                  to the best of your knowledge, the provision of the
                  information and/or recommendations hereunder will not violate
                  any laws or regulations applicable to you.
                </li>
                <li>
                  Your firm has policies and procedures to evaluate the
                  performance, fitness and properness of its employees to
                  provide recommendations (e.g., via this website), including:
                  (a) an assessment of whether such employees are bad actors and
                  (b) a periodic background check on such individuals.
                </li>
              </ul>
            </Paragraph>
            <IdeyaTypography.Title level={4}>
              Licensed Data Sources
            </IdeyaTypography.Title>
            <IdeyaTypography.Text>
              You understand and agree that (a) IDEYA may contain market data
              that is licensed from third party data providers ("Licensed
              Data"), (b) you agree that you may not redistribute or use the
              Licensed Data for any manner except to facilitate your use of the
              relevant site for the purpose of these terms and conditions and
              submission of trade ideas; (c) neither PCMHK nor any of the
              sources of Licensed Data, or any of their affiliates, shall have
              any liability relating to the display of the Licensed Data or any
              losses or claims arising from your use of the Licensed Data; (d)
              third party data providers own all intellectual property rights in
              the Licensed Data and may assert rights therein in connection with
              unauthorized use of the Licensed Data; (e) a third party data
              provider may suspend or terminate receipt or use of Licensed Data
              by you if such provider has reason to believe the Licensed Data is
              being misused or misrepresented; and (f) PCMHK and the third-party
              providers of Licensed Data have the right to monitor your
              compliance with use restrictions on Licensed Data.
            </IdeyaTypography.Text>
            <IdeyaTypography.Title level={4}>
              Accuracy of Information
            </IdeyaTypography.Title>
            <IdeyaTypography.Text>
              IDEYA may be linked to additional third-party websites or contain
              information provided by additional third parties. The information
              contained on IDEYA has been obtained from, or is based on, sources
              believed to be reliable, but is not guaranteed as to its accuracy
              or completeness. Neither PCMHK nor any of its affiliates, make any
              representation as to the accuracy or completeness of such websites
              or information, and advise you that they have not and will not
              review or update such websites or information, and caution you and
              your firm that any use made of such websites or information is at
              your own risk.
            </IdeyaTypography.Text>
            <IdeyaTypography.Title level={4}>
              No Liability
            </IdeyaTypography.Title>
            <IdeyaTypography.Text>
              The information contained on IDEYA has been prepared, approved and
              published in good faith and on the basis of publicly available
              information, internally developed data and sources believed to be
              reliable as of the date of publication. However, no
              representation, warranty or undertaking, express or implied, is
              made by PCMHK or any of its affiliates, or any other person as to
              the reliability, accuracy or completeness of the information
              contained on therein, and no liability is accepted by such persons
              for the reliability, accuracy or completeness of such information.
            </IdeyaTypography.Text>
            <IdeyaTypography.Text>
              You should be aware that the Internet is not a completely reliable
              transmission medium. Neither PCMHK nor or any of its affiliates
              accepts any liability for any data transmission errors such as
              data loss or damage or alteration of any kind, including, but not
              limited to any direct, indirect or consequential damage, arising
              out of the use of IDEYA or any other products or services referred
              to herein. In addition, neither IDEYA or any of its affiliates,
              accept any responsibility for the security or confidentiality of
              information transmitted across the internet to or from any of them
              and any such transmission of information is entirely at your own
              risk.
            </IdeyaTypography.Text>
            <IdeyaTypography.Title level={4}>
              Indemnification
            </IdeyaTypography.Title>
            <IdeyaTypography.Text>
              You agree to indemnify and hold harmless PCMHK or any and its
              affiliates, and their respective officers, directors, employees,
              agents, representatives, successors and assigns from any and all
              actions, causes of action, claims, charges, demands, cost,
              expenses and damages (including any reasonable legal fees and
              expenses) and liabilities of any kind whatsoever directly or
              indirectly resulting from, arising out of or in connection with
              your breach or violation of any and all provisions of these terms
              and conditions.
            </IdeyaTypography.Text>
            <IdeyaTypography.Title level={4}>Termination</IdeyaTypography.Title>
            <IdeyaTypography.Text>
              The rights granted to you herein terminate immediately upon any
              violation by you of these terms of use. PCMHK reserves the right
              to terminate your access to IDEYA at any time, without notice, for
              any reason whatsoever. You agree that neither PCMHK nor any of its
              affiliates shall be liable to you or any third party for any
              termination of your access to IDEYA or other sites owned or
              operated by any of them or their affiliates.
            </IdeyaTypography.Text>
            <IdeyaTypography.Title level={4}>
              Governing Law and Jurisdiction
            </IdeyaTypography.Title>
            <IdeyaTypography.Text>
              Your use of IDEYA and the operation of these terms and conditions
              shall be governed by and interpreted in accordance with the laws
              of Hong Kong. The Hong Kong courts shall have exclusive
              jurisdiction over any dispute arising out of your use of IDEYA.
            </IdeyaTypography.Text>
            <IdeyaTypography.Title level={4}>
              Entire Agreement; Severability
            </IdeyaTypography.Title>
            <IdeyaTypography.Text>
              These terms and conditions represent the entire agreement between
              you and PCMHK relating to the subject matter herein. If any
              provision in these terms and conditions is deemed unlawful,
              invalid, or for any reason unenforceable, then that provision will
              be deemed severed from, and will not affect the validity and
              enforceability of, the remaining provisions.
            </IdeyaTypography.Text>
            <IdeyaTypography.Title level={4}>
              Acceptance of Conditions of Use
            </IdeyaTypography.Title>
            <IdeyaTypography.Text>
              If you have read and understood these conditions of use you may
              click the “Accept” button to proceed. By doing so you acknowledge
              that you understand these terms and conditions of use and agreed
              to abide by them.
            </IdeyaTypography.Text>
            <IdeyaTypography.Text style={{ color: '#FF7875' }}>
              Clicking this “Accept” button means you accept these terms and
              conditions and you represent that you have the right to bind your
              firm to these terms.
            </IdeyaTypography.Text>
          </Row>
          <Button
            icon={<VerticalAlignBottomOutlined />}
            style={{
              position: 'sticky',
              bottom: 16,
              right: 16,
              float: 'right',
              zIndex: 2,
              borderRadius: 6,
              background: '#f5f5f5',
              border: '1px solid #d9d9d9',
              color: '#4E8DA8',
              marginTop: 16,
              width: isMobile ? 40 : undefined,
              height: isMobile ? 40 : undefined,
              minWidth: isMobile ? 40 : undefined,
              padding: isMobile ? 0 : undefined,
            }}
            onClick={handleScrollClick}
          ></Button>
        </div>
      </Card>
      <div
        style={{
          display: 'flex',
          flexDirection: 'row',
          justifyContent: isMobile ? 'center' : 'flex-end',
          alignItems: isMobile ? 'stretch' : 'center',
          gap: 16,
          position: 'static',
          width: isMobile ? '98vw' : 1320, // Match the card width
          maxWidth: '98vw',
          margin: '16px 0px',
        }}
      >
        <Button
          style={{
            borderRadius: '6px',
            border: '1px solid #6EA3BA',
            background: '#FFF',
            boxShadow: '0px 2px 0px 0px rgba(5, 145, 255, 0.1)',
            color: '#4E8DA8',
            width: isMobile ? '100%' : 170,
            marginBottom: isMobile ? 8 : 0,
          }}
          onClick={() => navigate('/logout')}
        >
          Reject
        </Button>
        <Button
          onClick={handleAccept}
          disabled={!scrolledToBottom}
          style={{
            borderRadius: '6px',
            border: !scrolledToBottom
              ? '1px solid rgba(0, 0, 0, 0.20)'
              : '1px solid #6EA3BA',
            opacity: !scrolledToBottom ? 0.5 : 1,
            background: !scrolledToBottom ? 'rgba(0, 0, 0, 0.20)' : '#CEE6F0',
            boxShadow: '0px 2px 0px 0px rgba(5, 145, 255, 0.10)',
            width: isMobile ? '100%' : 170,
            color: !scrolledToBottom ? 'rgba(0, 0, 0, 0.4)' : '#4E8DA8',
          }}
        >
          Accept
        </Button>
      </div>
    </div>
  )
}
